// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/common/v1/types.proto (package mono.common.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * ReviewItemKind says what a reviewer must supply for a fact code could not
 * settle (D86): a value the documents disagree on, or the object the fact
 * belongs to.
 *
 * @generated from enum mono.common.v1.ReviewItemKind
 */ export var ReviewItemKind = /*#__PURE__*/ function(ReviewItemKind) {
    /**
   * @generated from enum value: REVIEW_ITEM_KIND_UNSPECIFIED = 0;
   */ ReviewItemKind[ReviewItemKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * The documents disagree, or the data does not fit; the reviewer supplies
   * the value (or leaves it unstated).
   *
   * @generated from enum value: REVIEW_ITEM_KIND_CONFLICT = 1;
   */ ReviewItemKind[ReviewItemKind["CONFLICT"] = 1] = "CONFLICT";
    /**
   * We cannot tell which line, task or period the fact belongs to; the
   * reviewer picks the target.
   *
   * @generated from enum value: REVIEW_ITEM_KIND_IDENTITY = 2;
   */ ReviewItemKind[ReviewItemKind["IDENTITY"] = 2] = "IDENTITY";
    return ReviewItemKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ReviewItemKind)
proto3.util.setEnumType(ReviewItemKind, "mono.common.v1.ReviewItemKind", [
    {
        no: 0,
        name: "REVIEW_ITEM_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REVIEW_ITEM_KIND_CONFLICT"
    },
    {
        no: 2,
        name: "REVIEW_ITEM_KIND_IDENTITY"
    }
]);
/**
 * ReviewReasonCode is the stable, machine-readable reason behind a review
 * item. The reviewer-facing sentence rides ReviewItem.reason; this code is
 * what counts, dedups and routes. Add a value when a new emitter lands.
 *
 * @generated from enum mono.common.v1.ReviewReasonCode
 */ export var ReviewReasonCode = /*#__PURE__*/ function(ReviewReasonCode) {
    /**
   * @generated from enum value: REVIEW_REASON_CODE_UNSPECIFIED = 0;
   */ ReviewReasonCode[ReviewReasonCode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * CT: a line's contract type is stated differently by two sources.
   *
   * @generated from enum value: REVIEW_REASON_CODE_CONTRACT_TYPE_CONFLICT = 1;
   */ ReviewReasonCode[ReviewReasonCode["CONTRACT_TYPE_CONFLICT"] = 1] = "CONTRACT_TYPE_CONFLICT";
    /**
   * K8-3: a schedule line's period of performance was not read.
   *
   * @generated from enum value: REVIEW_REASON_CODE_POP_NOT_READ = 2;
   */ ReviewReasonCode[ReviewReasonCode["POP_NOT_READ"] = 2] = "POP_NOT_READ";
    /**
   * K9b/K9c: a modification states no effective date.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_EFFECTIVE_DATE_NOT_STATED = 3;
   */ ReviewReasonCode[ReviewReasonCode["MOD_EFFECTIVE_DATE_NOT_STATED"] = 3] = "MOD_EFFECTIVE_DATE_NOT_STATED";
    /**
   * K9c Q3: an option exercise states no date.
   *
   * @generated from enum value: REVIEW_REASON_CODE_EXERCISE_DATE_NOT_STATED = 4;
   */ ReviewReasonCode[ReviewReasonCode["EXERCISE_DATE_NOT_STATED"] = 4] = "EXERCISE_DATE_NOT_STATED";
    /**
   * A period-of-performance change names no line or period it applies to.
   *
   * @generated from enum value: REVIEW_REASON_CODE_POP_CHANGE_UNTARGETED = 5;
   */ ReviewReasonCode[ReviewReasonCode["POP_CHANGE_UNTARGETED"] = 5] = "POP_CHANGE_UNTARGETED";
    /**
   * K9c Q5: clashing labor-category parentheticals leave the scope name open.
   *
   * @generated from enum value: REVIEW_REASON_CODE_SCOPE_NAME_CLASH = 6;
   */ ReviewReasonCode[ReviewReasonCode["SCOPE_NAME_CLASH"] = 6] = "SCOPE_NAME_CLASH";
    /**
   * M5: a split's parts do not sum to the stated total.
   *
   * @generated from enum value: REVIEW_REASON_CODE_SPLIT_NOT_SUMMING = 7;
   */ ReviewReasonCode[ReviewReasonCode["SPLIT_NOT_SUMMING"] = 7] = "SPLIT_NOT_SUMMING";
    /**
   * M6: the modification type was read below the confidence gate.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_TYPE_UNDER_GATE = 8;
   */ ReviewReasonCode[ReviewReasonCode["MOD_TYPE_UNDER_GATE"] = 8] = "MOD_TYPE_UNDER_GATE";
    /**
   * M6: the modification purpose was read below the confidence gate.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_PURPOSE_UNDER_GATE = 9;
   */ ReviewReasonCode[ReviewReasonCode["MOD_PURPOSE_UNDER_GATE"] = 9] = "MOD_PURPOSE_UNDER_GATE";
    /**
   * A modification was written by the v1 fallback, with no field-level
   * comparison and no change set.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_APPLIED_WITHOUT_COMPARISON = 10;
   */ ReviewReasonCode[ReviewReasonCode["MOD_APPLIED_WITHOUT_COMPARISON"] = 10] = "MOD_APPLIED_WITHOUT_COMPARISON";
    /**
   * K9c Q2: an Add names an existing line whose values differ.
   *
   * @generated from enum value: REVIEW_REASON_CODE_ADD_EXISTING_LINE_DIFFERS = 11;
   */ ReviewReasonCode[ReviewReasonCode["ADD_EXISTING_LINE_DIFFERS"] = 11] = "ADD_EXISTING_LINE_DIFFERS";
    /**
   * K11: a line could not be tied to its parent or schedule row.
   *
   * @generated from enum value: REVIEW_REASON_CODE_LINE_IDENTITY_UNRESOLVED = 12;
   */ ReviewReasonCode[ReviewReasonCode["LINE_IDENTITY_UNRESOLVED"] = 12] = "LINE_IDENTITY_UNRESOLVED";
    /**
   * A stored line or section number does not fit its grammar (the archive
   * engine's field-shape lint, merged from its source_correction kind).
   *
   * @generated from enum value: REVIEW_REASON_CODE_FIELD_SHAPE_INVALID = 13;
   */ ReviewReasonCode[ReviewReasonCode["FIELD_SHAPE_INVALID"] = 13] = "FIELD_SHAPE_INVALID";
    /**
   * A CLIN/SLIN family skips a number, or an option period lacks a line every
   * sibling period has (archive contract_integrity_issue).
   *
   * @generated from enum value: REVIEW_REASON_CODE_CLIN_SEQUENCE_GAP = 14;
   */ ReviewReasonCode[ReviewReasonCode["CLIN_SEQUENCE_GAP"] = 14] = "CLIN_SEQUENCE_GAP";
    /**
   * A citation names a PWS section the outline does not declare (archive
   * contract_integrity_issue).
   *
   * @generated from enum value: REVIEW_REASON_CODE_DANGLING_PWS_REFERENCE = 15;
   */ ReviewReasonCode[ReviewReasonCode["DANGLING_PWS_REFERENCE"] = 15] = "DANGLING_PWS_REFERENCE";
    /**
   * A requirement cites an attachment no document supplies (archive
   * contract_integrity_issue).
   *
   * @generated from enum value: REVIEW_REASON_CODE_CITED_ATTACHMENT_ABSENT = 16;
   */ ReviewReasonCode[ReviewReasonCode["CITED_ATTACHMENT_ABSENT"] = 16] = "CITED_ATTACHMENT_ABSENT";
    /**
   * D96: a later document restates a value that differs from the one a
   * reviewer (or an earlier document) settled.
   *
   * @generated from enum value: REVIEW_REASON_CODE_LATER_DOCUMENT_CONTRADICTS = 17;
   */ ReviewReasonCode[ReviewReasonCode["LATER_DOCUMENT_CONTRADICTS"] = 17] = "LATER_DOCUMENT_CONTRADICTS";
    /**
   * K9b-3 (D88 Q4, D97): money reaches an option period, or an optional
   * task, that no document says was exercised. Funding alone never marks it
   * exercised: the reviewer states the exercise, or records it as funded,
   * not exercised (the money still counts).
   *
   * @generated from enum value: REVIEW_REASON_CODE_OPTION_PERIOD_FUNDED_NOT_EXERCISED = 18;
   */ ReviewReasonCode[ReviewReasonCode["OPTION_PERIOD_FUNDED_NOT_EXERCISED"] = 18] = "OPTION_PERIOD_FUNDED_NOT_EXERCISED";
    /**
   * K9b-2 (D97): a line's funded change resolves to no period, or to more
   * than one, so a reviewer picks the period it belongs to.
   *
   * @generated from enum value: REVIEW_REASON_CODE_PERIOD_FUNDING_UNRESOLVED = 19;
   */ ReviewReasonCode[ReviewReasonCode["PERIOD_FUNDING_UNRESOLVED"] = 19] = "PERIOD_FUNDING_UNRESOLVED";
    /**
   * D100 (RI-3c): a modification states a current completion date that
   * differs from the one derived from the lines and periods exercised as of
   * it.
   *
   * @generated from enum value: REVIEW_REASON_CODE_COMPLETION_DATE_CLAIM_DIFFERS = 20;
   */ ReviewReasonCode[ReviewReasonCode["COMPLETION_DATE_CLAIM_DIFFERS"] = 20] = "COMPLETION_DATE_CLAIM_DIFFERS";
    /**
   * K9c-1b (D103): one document states two different values for one field
   * (a task's ceiling printed two ways, two caps for one task). Both are
   * candidates, each with its quote; the reviewer picks, code never does.
   *
   * @generated from enum value: REVIEW_REASON_CODE_DOCUMENT_STATES_TWO_VALUES = 21;
   */ ReviewReasonCode[ReviewReasonCode["DOCUMENT_STATES_TWO_VALUES"] = 21] = "DOCUMENT_STATES_TWO_VALUES";
    /**
   * K10a: a modification's own line schedule was not read for the
   * comparison against the lines on file (the lines could not be listed, no
   * time was left, the read failed, or it returned nothing), so whether each
   * funding item adds a line or amends one is unchecked. One per
   * modification; nothing is written, the reviewer closes it with a reason.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_LINE_SCHEDULE_UNREAD = 22;
   */ ReviewReasonCode[ReviewReasonCode["MOD_LINE_SCHEDULE_UNREAD"] = 22] = "MOD_LINE_SCHEDULE_UNREAD";
    /**
   * K10a: the funding items staged from a modification, each obligation
   * counted once across a line and its sub-lines, do not add to the total
   * the modification states it obligates. One per modification; nothing is
   * written, the reviewer checks the funding and closes it with a reason.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_OBLIGATION_TOTAL_DIFFERS = 23;
   */ ReviewReasonCode[ReviewReasonCode["MOD_OBLIGATION_TOTAL_DIFFERS"] = 23] = "MOD_OBLIGATION_TOTAL_DIFFERS";
    /**
   * S5a: a modification adds lines that carry deliverables, and no writer
   * applies a modification's deliverables (Mint owns every date). One per
   * modification, naming each line and its deliverables; accepting it records
   * Acknowledged and writes nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_MOD_LINE_DELIVERABLES_UNHANDLED = 24;
   */ ReviewReasonCode[ReviewReasonCode["MOD_LINE_DELIVERABLES_UNHANDLED"] = 24] = "MOD_LINE_DELIVERABLES_UNHANDLED";
    /**
   * S5a: a modification exercises an optional task in words alone and none
   * of its lines states the window the task is exercised for. One per task
   * per modification; the reviewer's {start, end} stamps the windowless
   * tranche, or the window is left blank (D98).
   *
   * @generated from enum value: REVIEW_REASON_CODE_EXERCISE_WINDOW_NOT_STATED = 25;
   */ ReviewReasonCode[ReviewReasonCode["EXERCISE_WINDOW_NOT_STATED"] = 25] = "EXERCISE_WINDOW_NOT_STATED";
    /**
   * S5b-1: a contract-wide date someone already filed or waived sits on a
   * tranche that now has more than one team, so which team's date it is
   * can't be told. The tranche's teams are the candidates.
   *
   * @generated from enum value: REVIEW_REASON_CODE_OCCURRENCE_OWNER_UNRESOLVED = 26;
   */ ReviewReasonCode[ReviewReasonCode["OCCURRENCE_OWNER_UNRESOLVED"] = 26] = "OCCURRENCE_OWNER_UNRESOLVED";
    /**
   * S7a: a due-cell field (or the rule text itself) was under the reader's
   * gate, so the cell stands and the candidate goes to the owner (D42/D86).
   *
   * @generated from enum value: REVIEW_REASON_CODE_DUE_RULE_UNDER_GATE = 27;
   */ ReviewReasonCode[ReviewReasonCode["DUE_RULE_UNDER_GATE"] = 27] = "DUE_RULE_UNDER_GATE";
    /**
   * S7b: the prose verb-link judgment did not clear the gate both ways, so
   * which verb the statement is stays open.
   *
   * @generated from enum value: REVIEW_REASON_CODE_PROSE_VERB_LINK_UNDECIDED = 28;
   */ ReviewReasonCode[ReviewReasonCode["PROSE_VERB_LINK_UNDECIDED"] = 28] = "PROSE_VERB_LINK_UNDECIDED";
    /**
   * S7a: a citation's subject (or a line title's condition) disagrees with
   * the cited heading; the matching heading is a candidate when exactly one
   * matches (D120).
   *
   * @generated from enum value: REVIEW_REASON_CODE_CROSS_REFERENCE_SUBJECT_DIFFERS = 29;
   */ ReviewReasonCode[ReviewReasonCode["CROSS_REFERENCE_SUBJECT_DIFFERS"] = 29] = "CROSS_REFERENCE_SUBJECT_DIFFERS";
    /**
   * S7b: a condition set has more than one branch and the award does not
   * say which holds; every branch's duties exist and none of them mint.
   *
   * @generated from enum value: REVIEW_REASON_CODE_CONDITION_BRANCH_UNRESOLVED = 30;
   */ ReviewReasonCode[ReviewReasonCode["CONDITION_BRANCH_UNRESOLVED"] = 30] = "CONDITION_BRANCH_UNRESOLVED";
    /**
   * SAD-775: the award schedules deliverables in a period (or an
   * optional task) the contract does not state. The duties stay; their rules
   * for it are not written, so nothing mints there. One per missing period
   * per program; nothing is written, the reviewer leaves it blank.
   *
   * @generated from enum value: REVIEW_REASON_CODE_DUTY_PERIOD_NOT_STATED = 31;
   */ ReviewReasonCode[ReviewReasonCode["DUTY_PERIOD_NOT_STATED"] = 31] = "DUTY_PERIOD_NOT_STATED";
    /**
   * SAD-791: a re-extract froze the program's CLIN snapshot (lines edited,
   * applied, or the new set smaller) and raised one intake item naming why.
   * Accepting records Acknowledged; nothing is written to the lines.
   *
   * @generated from enum value: REVIEW_REASON_CODE_LINE_SNAPSHOT_FROZEN = 32;
   */ ReviewReasonCode[ReviewReasonCode["LINE_SNAPSHOT_FROZEN"] = 32] = "LINE_SNAPSHOT_FROZEN";
    /**
   * SAD-791: a live period the new extraction no longer produces. Accept
   * removes it (refused by name while lines, funding or occurrences still
   * point at it); Leave blank keeps it.
   *
   * @generated from enum value: REVIEW_REASON_CODE_PERIOD_NO_LONGER_IN_DOCUMENT = 33;
   */ ReviewReasonCode[ReviewReasonCode["PERIOD_NO_LONGER_IN_DOCUMENT"] = 33] = "PERIOD_NO_LONGER_IN_DOCUMENT";
    /**
   * SAD-791: a re-extract restated a decided-but-unapplied intake item with
   * a different value. The original decision stays; this item asks whether
   * to keep it. The keep answer is the default.
   *
   * @generated from enum value: REVIEW_REASON_CODE_KEEP_DECISION = 34;
   */ ReviewReasonCode[ReviewReasonCode["KEEP_DECISION"] = 34] = "KEEP_DECISION";
    /**
   * SAD-768: the reviewer adds a line extraction dropped (empty field path =
   * object add). Accept writes the line; Leave blank writes nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_REVIEWER_ADDED_LINE = 35;
   */ ReviewReasonCode[ReviewReasonCode["REVIEWER_ADDED_LINE"] = 35] = "REVIEWER_ADDED_LINE";
    /**
   * SAD-768: the reviewer corrects a line's title (or other fields staged
   * beside it). Accept writes the correction; Leave blank writes nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_REVIEWER_CORRECTED_LINE = 36;
   */ ReviewReasonCode[ReviewReasonCode["REVIEWER_CORRECTED_LINE"] = 36] = "REVIEWER_CORRECTED_LINE";
    /**
   * SAD-886: a modification exercises an optional task by a number the
   * program does not hold, and the lines it names do not settle which task it
   * is. Accept writes the exercise on the picked task; Leave blank writes
   * nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_OPTIONAL_TASK_NOT_ON_FILE = 37;
   */ ReviewReasonCode[ReviewReasonCode["OPTIONAL_TASK_NOT_ON_FILE"] = 37] = "OPTIONAL_TASK_NOT_ON_FILE";
    /**
   * SAD-969 (D106): a SOW never mentions an award deliverable on its team's
   * exercised tasks. One item per deliverable, grouped per SOW in review.
   * Accept writes the SOW's assignment: performed (owed per the award
   * schedule) or not owed with a reason. Until answered the award governs.
   *
   * @generated from enum value: REVIEW_REASON_CODE_SOW_SILENT_ON_DUTY = 38;
   */ ReviewReasonCode[ReviewReasonCode["SOW_SILENT_ON_DUTY"] = 38] = "SOW_SILENT_ON_DUTY";
    /**
   * SAD-979: a re-extract of the award on file states a deliverable under a
   * key an earlier read kept apart (a key it replaces): is it the same one?
   * Accept "same" (the default, as the code read it) re-keys or folds on
   * commit; "different" keeps both. Identity item on the ContractIntake set.
   *
   * @generated from enum value: REVIEW_REASON_CODE_AWARD_REREAD_SAME_DELIVERABLE = 39;
   */ ReviewReasonCode[ReviewReasonCode["AWARD_REREAD_SAME_DELIVERABLE"] = 39] = "AWARD_REREAD_SAME_DELIVERABLE";
    /**
   * SAD-979: a re-extract states a deliverable that is not on file. Accept
   * "Add it" writes it (the priced-duty carrier) and its rules on commit;
   * "Leave it out" writes nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_AWARD_REREAD_NEW_DELIVERABLE = 40;
   */ ReviewReasonCode[ReviewReasonCode["AWARD_REREAD_NEW_DELIVERABLE"] = 40] = "AWARD_REREAD_NEW_DELIVERABLE";
    /**
   * SAD-980: a re-extract of the award on file reads a different line set.
   * One item for the whole set: "Use the re-read lines" replaces the lines
   * and the money they roll up to on commit; "Keep current lines" (the
   * default) writes nothing. line_set_diff says what each line change is.
   * On the re-read path it replaces LINE_SNAPSHOT_FROZEN's freeze.
   *
   * @generated from enum value: REVIEW_REASON_CODE_AWARD_REREAD_LINE_SET = 41;
   */ ReviewReasonCode[ReviewReasonCode["AWARD_REREAD_LINE_SET"] = 41] = "AWARD_REREAD_LINE_SET";
    /**
   * A modification states an exercise whose optional task the document does
   * not settle: it names only lines that its schedule prints under more than
   * one task (or under none), or its task list does not read. One item per
   * exercising statement. Accept writes the exercise on the picked task, the
   * same way a parsed exercise is written; "Not an exercise" writes nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_OPTIONAL_TASK_EXERCISE_UNREAD = 42;
   */ ReviewReasonCode[ReviewReasonCode["OPTIONAL_TASK_EXERCISE_UNREAD"] = 42] = "OPTIONAL_TASK_EXERCISE_UNREAD";
    /**
   * M4: an optional task's PWS clause says the task performs the deliverables
   * of another section ("in accordance with all requirements cited in PWS
   * 5.2"), and the cited section is the one the clause names. One item per
   * cited section, naming every task that cites it and the deliverables it
   * reaches: confirmed once for the program, never per SOW. Accept the section
   * (the default) and teams linked on those tasks owe them unless their SOW
   * says otherwise; "none" gives them nothing. A cited section the award does
   * not have, or whose heading differs, is CROSS_REFERENCE_SUBJECT_DIFFERS on
   * the same target instead.
   *
   * @generated from enum value: REVIEW_REASON_CODE_PWS_CLAUSE_INHERITS_DELIVERABLES = 43;
   */ ReviewReasonCode[ReviewReasonCode["PWS_CLAUSE_INHERITS_DELIVERABLES"] = 43] = "PWS_CLAUSE_INHERITS_DELIVERABLES";
    /**
   * A document states a ceiling for the whole order that names no line and
   * no kind of ceiling code knows. The kinds are the candidates; Accept
   * writes the picked one, Leave blank writes nothing.
   *
   * @generated from enum value: REVIEW_REASON_CODE_ORDER_CEILING_KIND_UNRESOLVED = 44;
   */ ReviewReasonCode[ReviewReasonCode["ORDER_CEILING_KIND_UNRESOLVED"] = 44] = "ORDER_CEILING_KIND_UNRESOLVED";
    /**
   * The award speaks of due dates on a weekend or holiday, but code cannot
   * read which way they move. The rolls are the candidates; Accept writes the
   * picked one as the program's deliverable roll and re-dates its deliverables.
   *
   * @generated from enum value: REVIEW_REASON_CODE_DELIVERABLE_ROLL_UNREAD = 45;
   */ ReviewReasonCode[ReviewReasonCode["DELIVERABLE_ROLL_UNREAD"] = 45] = "DELIVERABLE_ROLL_UNREAD";
    /**
   * R15-A: a team's SOW owes a deliverable on a schedule that dates nothing
   * over the days it is in force: its start never resolves (an event nobody
   * logged, or no first date). One per SOW assignment. "keep" leaves it owed
   * as the SOW reads; "sow_start" runs it from the SOW's own start.
   *
   * @generated from enum value: REVIEW_REASON_CODE_OWED_SERIES_UNDATED = 46;
   */ ReviewReasonCode[ReviewReasonCode["OWED_SERIES_UNDATED"] = 46] = "OWED_SERIES_UNDATED";
    return ReviewReasonCode;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ReviewReasonCode)
proto3.util.setEnumType(ReviewReasonCode, "mono.common.v1.ReviewReasonCode", [
    {
        no: 0,
        name: "REVIEW_REASON_CODE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REVIEW_REASON_CODE_CONTRACT_TYPE_CONFLICT"
    },
    {
        no: 2,
        name: "REVIEW_REASON_CODE_POP_NOT_READ"
    },
    {
        no: 3,
        name: "REVIEW_REASON_CODE_MOD_EFFECTIVE_DATE_NOT_STATED"
    },
    {
        no: 4,
        name: "REVIEW_REASON_CODE_EXERCISE_DATE_NOT_STATED"
    },
    {
        no: 5,
        name: "REVIEW_REASON_CODE_POP_CHANGE_UNTARGETED"
    },
    {
        no: 6,
        name: "REVIEW_REASON_CODE_SCOPE_NAME_CLASH"
    },
    {
        no: 7,
        name: "REVIEW_REASON_CODE_SPLIT_NOT_SUMMING"
    },
    {
        no: 8,
        name: "REVIEW_REASON_CODE_MOD_TYPE_UNDER_GATE"
    },
    {
        no: 9,
        name: "REVIEW_REASON_CODE_MOD_PURPOSE_UNDER_GATE"
    },
    {
        no: 10,
        name: "REVIEW_REASON_CODE_MOD_APPLIED_WITHOUT_COMPARISON"
    },
    {
        no: 11,
        name: "REVIEW_REASON_CODE_ADD_EXISTING_LINE_DIFFERS"
    },
    {
        no: 12,
        name: "REVIEW_REASON_CODE_LINE_IDENTITY_UNRESOLVED"
    },
    {
        no: 13,
        name: "REVIEW_REASON_CODE_FIELD_SHAPE_INVALID"
    },
    {
        no: 14,
        name: "REVIEW_REASON_CODE_CLIN_SEQUENCE_GAP"
    },
    {
        no: 15,
        name: "REVIEW_REASON_CODE_DANGLING_PWS_REFERENCE"
    },
    {
        no: 16,
        name: "REVIEW_REASON_CODE_CITED_ATTACHMENT_ABSENT"
    },
    {
        no: 17,
        name: "REVIEW_REASON_CODE_LATER_DOCUMENT_CONTRADICTS"
    },
    {
        no: 18,
        name: "REVIEW_REASON_CODE_OPTION_PERIOD_FUNDED_NOT_EXERCISED"
    },
    {
        no: 19,
        name: "REVIEW_REASON_CODE_PERIOD_FUNDING_UNRESOLVED"
    },
    {
        no: 20,
        name: "REVIEW_REASON_CODE_COMPLETION_DATE_CLAIM_DIFFERS"
    },
    {
        no: 21,
        name: "REVIEW_REASON_CODE_DOCUMENT_STATES_TWO_VALUES"
    },
    {
        no: 22,
        name: "REVIEW_REASON_CODE_MOD_LINE_SCHEDULE_UNREAD"
    },
    {
        no: 23,
        name: "REVIEW_REASON_CODE_MOD_OBLIGATION_TOTAL_DIFFERS"
    },
    {
        no: 24,
        name: "REVIEW_REASON_CODE_MOD_LINE_DELIVERABLES_UNHANDLED"
    },
    {
        no: 25,
        name: "REVIEW_REASON_CODE_EXERCISE_WINDOW_NOT_STATED"
    },
    {
        no: 26,
        name: "REVIEW_REASON_CODE_OCCURRENCE_OWNER_UNRESOLVED"
    },
    {
        no: 27,
        name: "REVIEW_REASON_CODE_DUE_RULE_UNDER_GATE"
    },
    {
        no: 28,
        name: "REVIEW_REASON_CODE_PROSE_VERB_LINK_UNDECIDED"
    },
    {
        no: 29,
        name: "REVIEW_REASON_CODE_CROSS_REFERENCE_SUBJECT_DIFFERS"
    },
    {
        no: 30,
        name: "REVIEW_REASON_CODE_CONDITION_BRANCH_UNRESOLVED"
    },
    {
        no: 31,
        name: "REVIEW_REASON_CODE_DUTY_PERIOD_NOT_STATED"
    },
    {
        no: 32,
        name: "REVIEW_REASON_CODE_LINE_SNAPSHOT_FROZEN"
    },
    {
        no: 33,
        name: "REVIEW_REASON_CODE_PERIOD_NO_LONGER_IN_DOCUMENT"
    },
    {
        no: 34,
        name: "REVIEW_REASON_CODE_KEEP_DECISION"
    },
    {
        no: 35,
        name: "REVIEW_REASON_CODE_REVIEWER_ADDED_LINE"
    },
    {
        no: 36,
        name: "REVIEW_REASON_CODE_REVIEWER_CORRECTED_LINE"
    },
    {
        no: 37,
        name: "REVIEW_REASON_CODE_OPTIONAL_TASK_NOT_ON_FILE"
    },
    {
        no: 38,
        name: "REVIEW_REASON_CODE_SOW_SILENT_ON_DUTY"
    },
    {
        no: 39,
        name: "REVIEW_REASON_CODE_AWARD_REREAD_SAME_DELIVERABLE"
    },
    {
        no: 40,
        name: "REVIEW_REASON_CODE_AWARD_REREAD_NEW_DELIVERABLE"
    },
    {
        no: 41,
        name: "REVIEW_REASON_CODE_AWARD_REREAD_LINE_SET"
    },
    {
        no: 42,
        name: "REVIEW_REASON_CODE_OPTIONAL_TASK_EXERCISE_UNREAD"
    },
    {
        no: 43,
        name: "REVIEW_REASON_CODE_PWS_CLAUSE_INHERITS_DELIVERABLES"
    },
    {
        no: 44,
        name: "REVIEW_REASON_CODE_ORDER_CEILING_KIND_UNRESOLVED"
    },
    {
        no: 45,
        name: "REVIEW_REASON_CODE_DELIVERABLE_ROLL_UNREAD"
    },
    {
        no: 46,
        name: "REVIEW_REASON_CODE_OWED_SERIES_UNDATED"
    }
]);
/**
 * ReviewLineageKind is one later document's bearing on an earlier review item
 * (D96).
 *
 * @generated from enum mono.common.v1.ReviewLineageKind
 */ export var ReviewLineageKind = /*#__PURE__*/ function(ReviewLineageKind) {
    /**
   * @generated from enum value: REVIEW_LINEAGE_KIND_UNSPECIFIED = 0;
   */ ReviewLineageKind[ReviewLineageKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * The item was open and the document restates a value: code settled it.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_SETTLED = 1;
   */ ReviewLineageKind[ReviewLineageKind["SETTLED"] = 1] = "SETTLED";
    /**
   * The item was open and the document changes the field explicitly: the
   * item closed, and the change is the document's own change item.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_SUPERSEDED = 2;
   */ ReviewLineageKind[ReviewLineageKind["SUPERSEDED"] = 2] = "SUPERSEDED";
    /**
   * The field was settled and the document restates the same value.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_CORROBORATED = 3;
   */ ReviewLineageKind[ReviewLineageKind["CORROBORATED"] = 3] = "CORROBORATED";
    /**
   * The field was settled and the document restates a different value: a
   * LATER_DOCUMENT_CONTRADICTS conflict is staged on the document's set.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_CONTRADICTED = 4;
   */ ReviewLineageKind[ReviewLineageKind["CONTRADICTED"] = 4] = "CONTRADICTED";
    /**
   * The field was settled and the document changes it explicitly: the
   * document's own change item carries the new value.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_CHANGED = 5;
   */ ReviewLineageKind[ReviewLineageKind["CHANGED"] = 5] = "CHANGED";
    /**
   * A line under this item's target raised the same finding on the document;
   * it is not raised again, and settling this item settles it.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_AFFECTED = 6;
   */ ReviewLineageKind[ReviewLineageKind["AFFECTED"] = 6] = "AFFECTED";
    /**
   * The document left this same field open again; it is not raised twice.
   *
   * @generated from enum value: REVIEW_LINEAGE_KIND_REPEATED = 7;
   */ ReviewLineageKind[ReviewLineageKind["REPEATED"] = 7] = "REPEATED";
    return ReviewLineageKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ReviewLineageKind)
proto3.util.setEnumType(ReviewLineageKind, "mono.common.v1.ReviewLineageKind", [
    {
        no: 0,
        name: "REVIEW_LINEAGE_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REVIEW_LINEAGE_KIND_SETTLED"
    },
    {
        no: 2,
        name: "REVIEW_LINEAGE_KIND_SUPERSEDED"
    },
    {
        no: 3,
        name: "REVIEW_LINEAGE_KIND_CORROBORATED"
    },
    {
        no: 4,
        name: "REVIEW_LINEAGE_KIND_CONTRADICTED"
    },
    {
        no: 5,
        name: "REVIEW_LINEAGE_KIND_CHANGED"
    },
    {
        no: 6,
        name: "REVIEW_LINEAGE_KIND_AFFECTED"
    },
    {
        no: 7,
        name: "REVIEW_LINEAGE_KIND_REPEATED"
    }
]);
/**
 * Principal represents the user or entity making a request.
 *
 * `functions` is the SDS functional-area roster the principal belongs to
 * (Delivery | Contracts | Finance | Subcontracts | HrOnboarding | Quality |
 * Deliverables | GrowthHandoff). Discrepancy resolution and other SDS
 * workflows gate on whether the principal's functions overlap with the
 * resource's functional_owner; see services/enies-lobby/policies/
 * discrepancy.yaml's `is_functional_owner` derived role.
 *
 * @generated from message mono.common.v1.Principal
 */ export class Principal extends Message {
    static fromBinary(bytes, options) {
        return new Principal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Principal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Principal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Principal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: repeated string roles = 3;
   */ _define_property(this, "roles", []), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated string scopes = 5;
   */ _define_property(this, "scopes", []), /**
   * @generated from field: map<string, string> attr = 6;
   */ _define_property(this, "attr", {}), /**
   * @generated from field: repeated string functions = 7;
   */ _define_property(this, "functions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Principal, "runtime", proto3);
_define_property(Principal, "typeName", "mono.common.v1.Principal");
_define_property(Principal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "scopes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "attr",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 7,
            name: "functions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * Resource represents the resource being accessed.
 *
 * @generated from message mono.common.v1.Resource
 */ export class Resource extends Message {
    static fromBinary(bytes, options) {
        return new Resource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Resource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Resource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Resource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: map<string, string> attr = 4;
   */ _define_property(this, "attr", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(Resource, "runtime", proto3);
_define_property(Resource, "typeName", "mono.common.v1.Resource");
_define_property(Resource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "attr",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * RequestMetadata carries common request context.
 *
 * @generated from message mono.common.v1.RequestMetadata
 */ export class RequestMetadata extends Message {
    static fromBinary(bytes, options) {
        return new RequestMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string request_id = 1;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestMetadata, "runtime", proto3);
_define_property(RequestMetadata, "typeName", "mono.common.v1.RequestMetadata");
_define_property(RequestMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PaginationRequest is used for paginated list requests.
 *
 * @generated from message mono.common.v1.PaginationRequest
 */ export class PaginationRequest extends Message {
    static fromBinary(bytes, options) {
        return new PaginationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PaginationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PaginationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PaginationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page_size = 1;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 2;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PaginationRequest, "runtime", proto3);
_define_property(PaginationRequest, "typeName", "mono.common.v1.PaginationRequest");
_define_property(PaginationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PaginationResponse carries pagination state in responses.
 *
 * @generated from message mono.common.v1.PaginationResponse
 */ export class PaginationResponse extends Message {
    static fromBinary(bytes, options) {
        return new PaginationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PaginationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PaginationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PaginationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string next_page_token = 1;
   */ _define_property(this, "nextPageToken", ""), /**
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PaginationResponse, "runtime", proto3);
_define_property(PaginationResponse, "typeName", "mono.common.v1.PaginationResponse");
_define_property(PaginationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DocumentBlock represents a single block of content with positioning.
 *
 * @generated from message mono.common.v1.DocumentBlock
 */ export class DocumentBlock extends Message {
    static fromBinary(bytes, options) {
        return new DocumentBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentBlock, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string content = 3;
   */ _define_property(this, "content", ""), /**
   * @generated from field: int32 page_number = 4;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: mono.common.v1.BoundingBox bounding_box = 5;
   */ _define_property(this, "boundingBox", void 0), /**
   * @generated from field: string section_number = 6;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: int32 level = 7;
   */ _define_property(this, "level", 0), /**
   * @generated from field: string parent_block_id = 8;
   */ _define_property(this, "parentBlockId", ""), /**
   * @generated from field: repeated string children = 9;
   */ _define_property(this, "children", []), /**
   * @generated from field: double confidence = 10;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: mono.common.v1.BlockMetadata metadata = 11;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentBlock, "runtime", proto3);
_define_property(DocumentBlock, "typeName", "mono.common.v1.DocumentBlock");
_define_property(DocumentBlock, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "bounding_box",
            kind: "message",
            T: BoundingBox
        },
        {
            no: 6,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "parent_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "children",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "metadata",
            kind: "message",
            T: BlockMetadata
        }
    ]));
/**
 * BoundingBox represents the position of a block on a page.
 *
 * @generated from message mono.common.v1.BoundingBox
 */ export class BoundingBox extends Message {
    static fromBinary(bytes, options) {
        return new BoundingBox().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BoundingBox().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BoundingBox().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BoundingBox, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double x = 1;
   */ _define_property(this, "x", 0), /**
   * @generated from field: double y = 2;
   */ _define_property(this, "y", 0), /**
   * @generated from field: double width = 3;
   */ _define_property(this, "width", 0), /**
   * @generated from field: double height = 4;
   */ _define_property(this, "height", 0), /**
   * @generated from field: int32 page = 5;
   */ _define_property(this, "page", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BoundingBox, "runtime", proto3);
_define_property(BoundingBox, "typeName", "mono.common.v1.BoundingBox");
_define_property(BoundingBox, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "x",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "y",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "width",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "height",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * BlockMetadata contains additional block formatting information.
 *
 * @generated from message mono.common.v1.BlockMetadata
 */ export class BlockMetadata extends Message {
    static fromBinary(bytes, options) {
        return new BlockMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlockMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlockMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlockMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double font_size = 1;
   */ _define_property(this, "fontSize", 0), /**
   * @generated from field: bool is_bold = 2;
   */ _define_property(this, "isBold", false), /**
   * @generated from field: bool is_italic = 3;
   */ _define_property(this, "isItalic", false), /**
   * @generated from field: int32 indentation = 4;
   */ _define_property(this, "indentation", 0), /**
   * @generated from field: string list_type = 5;
   */ _define_property(this, "listType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlockMetadata, "runtime", proto3);
_define_property(BlockMetadata, "typeName", "mono.common.v1.BlockMetadata");
_define_property(BlockMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "font_size",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "is_bold",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "is_italic",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "indentation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "list_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * BlockExtractionResult contains all blocks extracted from a document.
 *
 * @generated from message mono.common.v1.BlockExtractionResult
 */ export class BlockExtractionResult extends Message {
    static fromBinary(bytes, options) {
        return new BlockExtractionResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlockExtractionResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlockExtractionResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlockExtractionResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 2;
   */ _define_property(this, "blocks", []), /**
   * @generated from field: mono.common.v1.BlockTreeNode block_tree = 3;
   */ _define_property(this, "blockTree", void 0), /**
   * @generated from field: int32 page_count = 4;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: int32 total_blocks = 5;
   */ _define_property(this, "totalBlocks", 0), /**
   * @generated from field: mono.common.v1.BlockStatistics statistics = 6;
   */ _define_property(this, "statistics", void 0), /**
   * @generated from field: int64 process_time_ms = 7;
   */ _define_property(this, "processTimeMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlockExtractionResult, "runtime", proto3);
_define_property(BlockExtractionResult, "typeName", "mono.common.v1.BlockExtractionResult");
_define_property(BlockExtractionResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 3,
            name: "block_tree",
            kind: "message",
            T: BlockTreeNode
        },
        {
            no: 4,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "total_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "statistics",
            kind: "message",
            T: BlockStatistics
        },
        {
            no: 7,
            name: "process_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * BlockTreeNode represents hierarchical document structure.
 *
 * @generated from message mono.common.v1.BlockTreeNode
 */ export class BlockTreeNode extends Message {
    static fromBinary(bytes, options) {
        return new BlockTreeNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlockTreeNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlockTreeNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlockTreeNode, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string block_id = 1;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: repeated mono.common.v1.BlockTreeNode children = 2;
   */ _define_property(this, "children", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlockTreeNode, "runtime", proto3);
_define_property(BlockTreeNode, "typeName", "mono.common.v1.BlockTreeNode");
_define_property(BlockTreeNode, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "children",
            kind: "message",
            T: BlockTreeNode,
            repeated: true
        }
    ]));
/**
 * BlockStatistics provides summary metrics.
 *
 * @generated from message mono.common.v1.BlockStatistics
 */ export class BlockStatistics extends Message {
    static fromBinary(bytes, options) {
        return new BlockStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlockStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlockStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlockStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_blocks = 1;
   */ _define_property(this, "totalBlocks", 0), /**
   * @generated from field: map<string, int32> blocks_by_type = 2;
   */ _define_property(this, "blocksByType", {}), /**
   * @generated from field: int32 page_count = 3;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: double avg_confidence = 4;
   */ _define_property(this, "avgConfidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlockStatistics, "runtime", proto3);
_define_property(BlockStatistics, "typeName", "mono.common.v1.BlockStatistics");
_define_property(BlockStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "blocks_by_type",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "avg_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * Provenance for a reusable document extraction, separate from review decisions.
 *
 * @generated from message mono.common.v1.ExtractionCacheInfo
 */ export class ExtractionCacheInfo extends Message {
    static fromBinary(bytes, options) {
        return new ExtractionCacheInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractionCacheInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractionCacheInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractionCacheInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool hit = 1;
   */ _define_property(this, "hit", false), /**
   * @generated from field: string source_md5 = 2;
   */ _define_property(this, "sourceMd5", ""), /**
   * @generated from field: string extraction_md5 = 3;
   */ _define_property(this, "extractionMd5", ""), /**
   * @generated from field: string profile_sha256 = 4;
   */ _define_property(this, "profileSha256", ""), /**
   * @generated from field: string model = 5;
   */ _define_property(this, "model", ""), /**
   * @generated from field: string extracted_at = 6;
   */ _define_property(this, "extractedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractionCacheInfo, "runtime", proto3);
_define_property(ExtractionCacheInfo, "typeName", "mono.common.v1.ExtractionCacheInfo");
_define_property(ExtractionCacheInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "hit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "source_md5",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "extraction_md5",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "profile_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "extracted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AwardDeliverableRoll is the award's stated weekend/holiday roll for due
 * dates (programs.deliverable_roll), with the clause it was read from. Absent
 * when the award states none: a roll is never assumed (D86).
 *
 * @generated from message mono.common.v1.AwardDeliverableRoll
 */ export class AwardDeliverableRoll extends Message {
    static fromBinary(bytes, options) {
        return new AwardDeliverableRoll().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardDeliverableRoll().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardDeliverableRoll().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardDeliverableRoll, a, b);
    }
    constructor(data){
        super(), /**
   * following_federal_workday | preceding_federal_workday | none
   *
   * @generated from field: string roll = 1;
   */ _define_property(this, "roll", ""), /**
   * @generated from field: mono.common.v1.ReviewSource source = 2;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardDeliverableRoll, "runtime", proto3);
_define_property(AwardDeliverableRoll, "typeName", "mono.common.v1.AwardDeliverableRoll");
_define_property(AwardDeliverableRoll, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roll",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "message",
            T: ReviewSource
        }
    ]));
/**
 * StatedObligation is the obligated (funded) total a document prints
 * (SAD-885): an award's Block 26 "Total Award Amount" or its "Funds in the
 * amount of $X are obligated" statements. It is the program's funded amount;
 * a sum of the lines' funding is only the fallback when nothing is printed.
 *
 * @generated from message mono.common.v1.StatedObligation
 */ export class StatedObligation extends Message {
    static fromBinary(bytes, options) {
        return new StatedObligation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatedObligation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatedObligation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatedObligation, a, b);
    }
    constructor(data){
        super(), /**
   * To the cent; 0 when the document prints none.
   *
   * @generated from field: double amount = 1;
   */ _define_property(this, "amount", 0), /**
   * How the amount was printed: award_block_26 | award_obligation_statement.
   *
   * @generated from field: string basis = 2;
   */ _define_property(this, "basis", ""), /**
   * Where it is printed.
   *
   * @generated from field: repeated mono.common.v1.ReviewSource sources = 3;
   */ _define_property(this, "sources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StatedObligation, "runtime", proto3);
_define_property(StatedObligation, "typeName", "mono.common.v1.StatedObligation");
_define_property(StatedObligation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        }
    ]));
/**
 * OrderCeiling is a ceiling the whole order carries, not one line: "The
 * Time-and-Materials Not-To-Exceed ceiling is $X", "Cost Reimbursable (CR)
 * line item for travel NTE ceiling has been changed to $Y".
 *
 * @generated from message mono.common.v1.OrderCeiling
 */ export class OrderCeiling extends Message {
    static fromBinary(bytes, options) {
        return new OrderCeiling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OrderCeiling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OrderCeiling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OrderCeiling, a, b);
    }
    constructor(data){
        super(), /**
   * time_and_materials | labor_hour | travel | cost_reimbursable |
   * other_direct_costs.
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * To the cent.
   *
   * @generated from field: double amount = 2;
   */ _define_property(this, "amount", 0), /**
   * Where it is printed.
   *
   * @generated from field: repeated mono.common.v1.ReviewSource sources = 3;
   */ _define_property(this, "sources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OrderCeiling, "runtime", proto3);
_define_property(OrderCeiling, "typeName", "mono.common.v1.OrderCeiling");
_define_property(OrderCeiling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        }
    ]));
/**
 * ReviewSource is one quote a reviewer reads to decide a review item: S7's
 * reference shape {element_ids, quote}, plus where it sits.
 *
 * @generated from message mono.common.v1.ReviewSource
 */ export class ReviewSource extends Message {
    static fromBinary(bytes, options) {
        return new ReviewSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 page = 2;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 3;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: repeated string element_ids = 4;
   */ _define_property(this, "elementIds", []), /**
   * @generated from field: mono.common.v1.BoundingBox bbox = 5;
   */ _define_property(this, "bbox", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewSource, "runtime", proto3);
_define_property(ReviewSource, "typeName", "mono.common.v1.ReviewSource");
_define_property(ReviewSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "element_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "bbox",
            kind: "message",
            T: BoundingBox
        }
    ]));
/**
 * ReviewCandidate is one value (conflict) or one target (identity) a reviewer
 * may pick.
 *
 * @generated from message mono.common.v1.ReviewCandidate
 */ export class ReviewCandidate extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCandidate, a, b);
    }
    constructor(data){
        super(), /**
   * Stable within the item; an identity pick records it.
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * The candidate value as JSON (conflict), or the target's natural key
   * (identity).
   *
   * @generated from field: string value_json = 3;
   */ _define_property(this, "valueJson", ""), /**
   * @generated from field: double score = 4;
   */ _define_property(this, "score", 0), /**
   * @generated from field: repeated mono.common.v1.ReviewSource sources = 5;
   */ _define_property(this, "sources", []), /**
   * Existing team this candidate resolves to. Empty means the candidate
   * proposes a new team.
   *
   * @generated from field: string workstream_id = 6;
   */ _define_property(this, "workstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCandidate, "runtime", proto3);
_define_property(ReviewCandidate, "typeName", "mono.common.v1.ReviewCandidate");
_define_property(ReviewCandidate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        },
        {
            no: 6,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReviewItem is a fact code could not settle (D86/D93). It rides the
 * extraction responses to the change set that stages it as a Blocking, Open
 * change item with this message in impact_json.review.
 *
 * @generated from message mono.common.v1.ReviewItem
 */ export class ReviewItem extends Message {
    static fromBinary(bytes, options) {
        return new ReviewItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.ReviewItemKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: mono.common.v1.ReviewReasonCode reason_code = 2;
   */ _define_property(this, "reasonCode", 0), /**
   * One reviewer-facing sentence naming why.
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * dispatchApply's vocabulary: ContractCLIN, ProgramModification,
   * OptionalTask, PeriodOfPerformance, Program.
   *
   * @generated from field: string target_object_type = 4;
   */ _define_property(this, "targetObjectType", ""), /**
   * The target's natural key, never a row id: a CLIN number, a modification
   * number, "option:2". Empty for an identity item with no guess.
   *
   * @generated from field: string target_locator = 5;
   */ _define_property(this, "targetLocator", ""), /**
   * The field in doubt (contract_type, pop_start_date, effective_date); empty
   * for a whole-object identity item.
   *
   * @generated from field: string target_field_path = 6;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: repeated mono.common.v1.ReviewCandidate candidates = 7;
   */ _define_property(this, "candidates", []), /**
   * @generated from field: repeated mono.common.v1.ReviewSource sources = 8;
   */ _define_property(this, "sources", []), /**
   * Stable dedup key over (reason_code, target_object_type, target_locator,
   * target_field_path). Re-syncs carry decisions over by it.
   *
   * @generated from field: string key = 9;
   */ _define_property(this, "key", ""), /**
   * The natural key of the target's parent when the finding is about a line
   * under one (a sub-line under its CLIN). Staging looks up the parent's item
   * on the same field by it (D96): a finding under an open parent item is
   * recorded as affected by that item instead of raised again.
   *
   * @generated from field: string parent_locator = 10;
   */ _define_property(this, "parentLocator", ""), /**
   * What later documents said about this item's field (D96), in chronological
   * order: which one settled, superseded, corroborated or contradicted it, and
   * the lines recorded as affected by it.
   *
   * @generated from field: repeated mono.common.v1.ReviewLineage lineage = 11;
   */ _define_property(this, "lineage", []), /**
   * The fact's own value as JSON when only its target is in doubt (an
   * identity item): staging carries it as the change item's
   * proposed_value_json, so assigning the target and accepting writes it.
   * Empty when the documents give no value.
   *
   * @generated from field: string value_json = 12;
   */ _define_property(this, "valueJson", ""), /**
   * Further targets of the same type and field that ask the same question
   * (one printed value repeated on several lines). The decision applies to
   * target_locator and to each of these, and each write is recorded on its
   * own target.
   *
   * @generated from field: repeated string also_target_locators = 13;
   */ _define_property(this, "alsoTargetLocators", []), /**
   * The document the item was read from, as the program names it (a SOW's
   * title), when it is not the change set's own document: a set that holds
   * several documents' items reviews each document's together (SAD-972).
   *
   * @generated from field: string document_label = 14;
   */ _define_property(this, "documentLabel", ""), /**
   * SAD-980: on a re-extract's line-set item, what accepting the read's
   * lines would change, computed when the item is staged.
   *
   * @generated from field: mono.common.v1.AwardLineSetDiff line_set_diff = 15;
   */ _define_property(this, "lineSetDiff", void 0), /**
   * A question several teams answer at once (a deliverable's dossier): each
   * team's own options, so the reviewer can answer each team separately.
   * The decided value is the first team's answer with every other team's
   * (and each answer's own further lines) as its further lines.
   *
   * @generated from field: repeated mono.common.v1.ReviewTeamAnswer team_answers = 16;
   */ _define_property(this, "teamAnswers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewItem, "runtime", proto3);
_define_property(ReviewItem, "typeName", "mono.common.v1.ReviewItem");
_define_property(ReviewItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(ReviewItemKind)
        },
        {
            no: 2,
            name: "reason_code",
            kind: "enum",
            T: proto3.getEnumType(ReviewReasonCode)
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "candidates",
            kind: "message",
            T: ReviewCandidate,
            repeated: true
        },
        {
            no: 8,
            name: "sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        },
        {
            no: 9,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "parent_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "lineage",
            kind: "message",
            T: ReviewLineage,
            repeated: true
        },
        {
            no: 12,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "also_target_locators",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "document_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "line_set_diff",
            kind: "message",
            T: AwardLineSetDiff
        },
        {
            no: 16,
            name: "team_answers",
            kind: "message",
            T: ReviewTeamAnswer,
            repeated: true
        }
    ]));
/**
 * One team's part of a question several teams answer at once.
 *
 * @generated from message mono.common.v1.ReviewTeamAnswer
 */ export class ReviewTeamAnswer extends Message {
    static fromBinary(bytes, options) {
        return new ReviewTeamAnswer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewTeamAnswer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewTeamAnswer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewTeamAnswer, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_id = 1;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string team_name = 2;
   */ _define_property(this, "teamName", ""), /**
   * The team's options: each candidate's value is this team's answer alone.
   *
   * @generated from field: repeated mono.common.v1.ReviewCandidate options = 3;
   */ _define_property(this, "options", []), /**
   * The option the reading leans to for this team; empty when unclear.
   *
   * @generated from field: string reading_key = 4;
   */ _define_property(this, "readingKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewTeamAnswer, "runtime", proto3);
_define_property(ReviewTeamAnswer, "typeName", "mono.common.v1.ReviewTeamAnswer");
_define_property(ReviewTeamAnswer, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "team_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "options",
            kind: "message",
            T: ReviewCandidate,
            repeated: true
        },
        {
            no: 4,
            name: "reading_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AwardLineSetDiff is what replacing the lines on file with a re-extract's
 * line set changes (SAD-980): each line added, removed or changed, and the
 * program's money before and after. Values are display-ready.
 *
 * @generated from message mono.common.v1.AwardLineSetDiff
 */ export class AwardLineSetDiff extends Message {
    static fromBinary(bytes, options) {
        return new AwardLineSetDiff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardLineSetDiff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardLineSetDiff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardLineSetDiff, a, b);
    }
    constructor(data){
        super(), /**
   * One plain sentence: "Re-reading the award would add 2 lines, remove 1
   * and change 3. Total ceiling $2,600,000.00 → $2,695,000.00."
   *
   * @generated from field: string summary = 1;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: int32 added = 2;
   */ _define_property(this, "added", 0), /**
   * @generated from field: int32 removed = 3;
   */ _define_property(this, "removed", 0), /**
   * @generated from field: int32 changed = 4;
   */ _define_property(this, "changed", 0), /**
   * @generated from field: int32 unchanged = 5;
   */ _define_property(this, "unchanged", 0), /**
   * The lines added, removed or changed, in line-number order.
   *
   * @generated from field: repeated mono.common.v1.AwardLineChange lines = 6;
   */ _define_property(this, "lines", []), /**
   * Total ceiling, contract value (TCV) and funded, before and after.
   *
   * @generated from field: repeated mono.common.v1.AwardValueChange money = 7;
   */ _define_property(this, "money", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardLineSetDiff, "runtime", proto3);
_define_property(AwardLineSetDiff, "typeName", "mono.common.v1.AwardLineSetDiff");
_define_property(AwardLineSetDiff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "changed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "unchanged",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "lines",
            kind: "message",
            T: AwardLineChange,
            repeated: true
        },
        {
            no: 7,
            name: "money",
            kind: "message",
            T: AwardValueChange,
            repeated: true
        }
    ]));
/**
 * AwardLineChange is one line a re-extract's line set adds, removes or
 * changes.
 *
 * @generated from message mono.common.v1.AwardLineChange
 */ export class AwardLineChange extends Message {
    static fromBinary(bytes, options) {
        return new AwardLineChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardLineChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardLineChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardLineChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * added | removed | changed
   *
   * @generated from field: string change = 2;
   */ _define_property(this, "change", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * An added line's fields (after only), a removed line's (before only), or
   * the fields a changed line reads differently.
   *
   * @generated from field: repeated mono.common.v1.AwardValueChange fields = 4;
   */ _define_property(this, "fields", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardLineChange, "runtime", proto3);
_define_property(AwardLineChange, "typeName", "mono.common.v1.AwardLineChange");
_define_property(AwardLineChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fields",
            kind: "message",
            T: AwardValueChange,
            repeated: true
        }
    ]));
/**
 * AwardValueChange is one field before and after, display-ready ("" when it
 * states none).
 *
 * @generated from message mono.common.v1.AwardValueChange
 */ export class AwardValueChange extends Message {
    static fromBinary(bytes, options) {
        return new AwardValueChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardValueChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardValueChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardValueChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string before = 3;
   */ _define_property(this, "before", ""), /**
   * @generated from field: string after = 4;
   */ _define_property(this, "after", ""), /**
   * @generated from field: bool changed = 5;
   */ _define_property(this, "changed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardValueChange, "runtime", proto3);
_define_property(AwardValueChange, "typeName", "mono.common.v1.AwardValueChange");
_define_property(AwardValueChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "before",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "changed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * AwardPricedDuty is one S7a priced-line duty on the award-import wire
 * (SAD-752 S7c-lite): baltigo's awardduties.Result carried through
 * ExtractCLINs → SyncFromExtraction → pangaea's ImportAwardDuties. Identity
 * is duty_key (D107); rules pin to a period or optional task the same way
 * the award prints them.
 *
 * @generated from message mono.common.v1.AwardPricedDuty
 */ export class AwardPricedDuty extends Message {
    static fromBinary(bytes, options) {
        return new AwardPricedDuty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardPricedDuty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardPricedDuty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardPricedDuty, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string duty_key = 1;
   */ _define_property(this, "dutyKey", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 3;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: string letter = 4;
   */ _define_property(this, "letter", ""), /**
   * @generated from field: repeated string source_lines = 5;
   */ _define_property(this, "sourceLines", []), /**
   * @generated from field: repeated mono.common.v1.AwardPricedDutyRule rules = 6;
   */ _define_property(this, "rules", []), /**
   * event_kind is the event this duty dates ("" = none): the award states a
   * deadline for the event itself ("a kickoff meeting shall be held within
   * 10 business days after award"), so the duty is that event's milestone
   * and rules anchored on the event project from its date.
   *
   * @generated from field: string event_kind = 7;
   */ _define_property(this, "eventKind", ""), /**
   * replaces_duty_keys are keys an earlier read of the same award gave this
   * duty: a PWS deliverable-list key ("x009:5.1.1:A") that a priced schedule
   * line now states and owns ("x009AA"), once an attachment carrying the
   * schedule is read with the award. An existing duty under one of them is
   * this duty, re-keyed rather than duplicated.
   *
   * @generated from field: repeated string replaces_duty_keys = 8;
   */ _define_property(this, "replacesDutyKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardPricedDuty, "runtime", proto3);
_define_property(AwardPricedDuty, "typeName", "mono.common.v1.AwardPricedDuty");
_define_property(AwardPricedDuty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_lines",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "rules",
            kind: "message",
            T: AwardPricedDutyRule,
            repeated: true
        },
        {
            no: 7,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "replaces_duty_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * AwardPricedDutyRule is one schedule rule on an AwardPricedDuty. Kind is
 * dated | recurring | event; gate is base | option_period | optional_task.
 * option_number is 0 for base and the option index for option_period;
 * optional_task_number is set when gate is optional_task. due_on is
 * YYYY-MM-DD when kind is dated (or the first date of a recurring series).
 *
 * @generated from message mono.common.v1.AwardPricedDutyRule
 */ export class AwardPricedDutyRule extends Message {
    static fromBinary(bytes, options) {
        return new AwardPricedDutyRule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardPricedDutyRule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardPricedDutyRule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardPricedDutyRule, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string gate = 1;
   */ _define_property(this, "gate", ""), /**
   * @generated from field: int32 option_number = 2;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: int32 optional_task_number = 3;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string rule_text = 5;
   */ _define_property(this, "ruleText", ""), /**
   * @generated from field: string source_locator = 6;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string due_on = 7;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: optional int32 offset_n = 8;
   */ _define_property(this, "offsetN", void 0), /**
   * @generated from field: string offset_unit = 9;
   */ _define_property(this, "offsetUnit", ""), /**
   * @generated from field: string cadence = 10;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: string event_kind = 11;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: string day_basis = 12;
   */ _define_property(this, "dayBasis", ""), /**
   * day_ordinals is the day of each period a recurring rule falls on ({5}
   * the 5th, {-1} the last), counted in day_basis; empty when none is stated.
   *
   * @generated from field: repeated int32 day_ordinals = 13;
   */ _define_property(this, "dayOrdinals", []), /**
   * anchor_duty_key names the deliverable whose act (anchor_act: accepted |
   * submitted) the rule counts from, by its duty_key ("Baseline due 30 days
   * after Quantum Commitment Plan acceptance"): pangaea anchors the rule on
   * that duty's trigger (SAD-835). anchor_act "due" is a rule due a number of
   * days before a milestone, the duty that dates a meeting ("draft agenda five
   * business days prior to the meeting"): pangaea makes it follow that duty's
   * scheduled dates (SAD-869). event_kind still names the event in words, for
   * when no duty under that key is on the program.
   *
   * @generated from field: string anchor_duty_key = 14;
   */ _define_property(this, "anchorDutyKey", ""), /**
   * @generated from field: string anchor_act = 15;
   */ _define_property(this, "anchorAct", ""), /**
   * day_weekday is the weekday a weekly or biweekly series falls on
   * ("friday" for "every Friday"), lower-case; "" when none is stated.
   *
   * @generated from field: string day_weekday = 16;
   */ _define_property(this, "dayWeekday", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardPricedDutyRule, "runtime", proto3);
_define_property(AwardPricedDutyRule, "typeName", "mono.common.v1.AwardPricedDutyRule");
_define_property(AwardPricedDutyRule, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rule_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "offset_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 9,
            name: "offset_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "day_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "day_ordinals",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 14,
            name: "anchor_duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "anchor_act",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "day_weekday",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReviewLineage is one entry of an item's lineage (D96).
 *
 * @generated from message mono.common.v1.ReviewLineage
 */ export class ReviewLineage extends Message {
    static fromBinary(bytes, options) {
        return new ReviewLineage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewLineage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewLineage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewLineage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.ReviewLineageKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * The later document's label (a modification number).
   *
   * @generated from field: string document = 2;
   */ _define_property(this, "document", ""), /**
   * The document's place in its modification numbering alone
   * (reviewitem.DocumentOrder): serial first, then series, so A00001 and
   * P00001 never share a place. Entries fold in chronological order
   * (reviewitem.Chronology), which reads document_effective_date first.
   *
   * @generated from field: int32 document_order = 3;
   */ _define_property(this, "documentOrder", 0), /**
   * @generated from field: string change_set_id = 4;
   */ _define_property(this, "changeSetId", ""), /**
   * The line the entry is about: the item's own target, or for AFFECTED and
   * REPEATED the line the document raised the finding on.
   *
   * @generated from field: string locator = 5;
   */ _define_property(this, "locator", ""), /**
   * The value the document states (JSON), for a statement entry.
   *
   * @generated from field: string value_json = 6;
   */ _define_property(this, "valueJson", ""), /**
   * The document states the value as an explicit change ("hereby changed",
   * FROM/TO) rather than a restatement.
   *
   * @generated from field: bool explicit_change = 7;
   */ _define_property(this, "explicitChange", false), /**
   * @generated from field: repeated mono.common.v1.ReviewSource sources = 8;
   */ _define_property(this, "sources", []), /**
   * RFC 3339; when staging first recorded the entry.
   *
   * @generated from field: string recorded_at = 9;
   */ _define_property(this, "recordedAt", ""), /**
   * The effective date the document states (YYYY-MM-DD); empty when it states
   * none. Only a stated date (D88), never when the document was applied. The
   * chronology orders by it first.
   *
   * @generated from field: string document_effective_date = 10;
   */ _define_property(this, "documentEffectiveDate", ""), /**
   * The statement restates the value the field held before the document
   * (ReviewStatement.prior); it folds ahead of the document's own change.
   *
   * @generated from field: bool prior = 11;
   */ _define_property(this, "prior", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewLineage, "runtime", proto3);
_define_property(ReviewLineage, "typeName", "mono.common.v1.ReviewLineage");
_define_property(ReviewLineage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(ReviewLineageKind)
        },
        {
            no: 2,
            name: "document",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "explicit_change",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        },
        {
            no: 9,
            name: "recorded_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "document_effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "prior",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * ReviewStatement is what a later document states about one field (D96): the
 * value it restates or changes, with its quote. Staging reconciles it against
 * the review items already on file for that field; a statement about a field
 * nobody asked about does nothing.
 *
 * @generated from message mono.common.v1.ReviewStatement
 */ export class ReviewStatement extends Message {
    static fromBinary(bytes, options) {
        return new ReviewStatement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewStatement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewStatement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewStatement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_locator = 2;
   */ _define_property(this, "targetLocator", ""), /**
   * @generated from field: string target_field_path = 3;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: string value_json = 4;
   */ _define_property(this, "valueJson", ""), /**
   * @generated from field: bool explicit_change = 5;
   */ _define_property(this, "explicitChange", false), /**
   * @generated from field: repeated mono.common.v1.ReviewSource sources = 6;
   */ _define_property(this, "sources", []), /**
   * The value is what the document states the field held before it (the
   * FROM of a printed FROM/TO row), not what it holds after: a restatement of
   * the earlier value, folded ahead of the document's own change (K9c-1b).
   *
   * @generated from field: bool prior = 7;
   */ _define_property(this, "prior", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewStatement, "runtime", proto3);
_define_property(ReviewStatement, "typeName", "mono.common.v1.ReviewStatement");
_define_property(ReviewStatement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "explicit_change",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        },
        {
            no: 7,
            name: "prior",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * WriteAttribution is who made a change and how (FND-27 AWR-4). Version and
 * history messages embed it instead of inventing their own fields.
 *
 * @generated from message mono.common.v1.WriteAttribution
 */ export class WriteAttribution extends Message {
    static fromBinary(bytes, options) {
        return new WriteAttribution().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteAttribution().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteAttribution().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteAttribution, a, b);
    }
    constructor(data){
        super(), /**
   * the human who made or accepted the change (approver)
   *
   * @generated from field: string actor_user_id = 1;
   */ _define_property(this, "actorUserId", ""), /**
   * resolved by the read handler; "" when unknown
   *
   * @generated from field: string actor_display_name = 2;
   */ _define_property(this, "actorDisplayName", ""), /**
   * "" (direct) | "specra_assist"
   *
   * @generated from field: string via = 3;
   */ _define_property(this, "via", ""), /**
   * "<conversation_id>:<tool_call_id>" when via = "specra_assist"
   *
   * @generated from field: string assist_run_id = 4;
   */ _define_property(this, "assistRunId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteAttribution, "runtime", proto3);
_define_property(WriteAttribution, "typeName", "mono.common.v1.WriteAttribution");
_define_property(WriteAttribution, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "actor_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "via",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assist_run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
